import { ArrowUpDown, ArrowUp, ArrowDown } from "lucide-react";
import { SortField, SortDirection } from "../../types/dashboard";

interface SortIconProps {
  field: SortField;
  sortField: SortField | null;
  sortDirection: SortDirection;
}

export function SortIcon({ field, sortField, sortDirection }: SortIconProps) {
  if (sortField !== field) {
    return <ArrowUpDown className="w-4 h-4 ml-1 inline text-muted-foreground opacity-0 group-hover:opacity-100 transition-opacity" />;
  }
  if (sortDirection === "asc") {
    return <ArrowUp className="w-4 h-4 ml-1 inline text-foreground" />;
  }
  return <ArrowDown className="w-4 h-4 ml-1 inline text-foreground" />;
}
